/* eslint-disable @typescript-eslint/no-unused-vars */
import { useTranslation } from "react-i18next";
import { Complaints1Svg, ComplaintsSvg, Logout, LostItemSvg, MedicalSvg, ProfileSvg, TicketsSvg, TransactionsSvg } from "../../common/svg/AllSvg";
import Profile from "./Profile";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Tickets from "./Tickets";
import Complaints from "./Complaints";
import { authActions } from "../../../shared/store/auth-Slice";
import Transactions from "./Transactions";
import LostItem from "./LostItem";
import MedicalDetails from "./MedicalDetails";
import { Helmet } from "react-helmet";
import { useState } from "react";

const Details = ({ type }: any) => {
    const user: any = useSelector((state: any) => state.auth.user);
    const [select, setSelect] = useState<any>("Pending_Review")
    const { t } = useTranslation('common');
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tabs: any = (type === "passenger" && (user?.role === "passenger" || user?.role === "candidate")) ? [
        { name: t("profile.tabs.profile"), key: "profile", url: "/profile", icon: ProfileSvg },
        { name: t("profile.tabs.medical"), key: "medical", url: "/medical-details", icon: MedicalSvg },
        { name: t("profile.tabs.tickets"), key: "tickets", url: "/tickets", icon: TicketsSvg },
        { name: t("profile.tabs.transactions"), key: "transactions", url: "/transactions", icon: TransactionsSvg },
        { name: t("profile.tabs.lost_item"), key: "lost-item", url: "/lost-item", icon: LostItemSvg },
        { name: t("profile.tabs.vigilance_complaint"), key: "vigilance-complaints", url: "/vigilance-complaints", icon: Complaints1Svg },
        { name: t("profile.tabs.grievance_complaint"), key: "grievance-complaints", url: "/grievance-complaints", icon: ComplaintsSvg },
    ] :
        [
            { name: t("profile.tabs.profile"), key: "profile", url: "/profile", icon: ProfileSvg }
        ]

    const handleLogout = async () => {
        dispatch(authActions.logout());
        if (window?.location?.pathname.includes("/admin")) {
            dispatch(authActions.adminDetail(null))
            navigate(!!params?.lang ? `/${params?.lang}/admin/login` : "/admin/login")
        } else {
            dispatch(authActions.userDetail(null))
            navigate(!!params?.lang ? `/${params?.lang}` : "/")
        }
    }

    return (
        <>
            {window.location.pathname?.includes?.("profile") ?
                <Helmet>
                    <title>{t("seo_friendly.passenger_profile.title")}</title>
                    <meta name="description" content={t("seo_friendly.passenger_profile.desc")} />
                </Helmet>
                : window.location.pathname?.includes?.("medical") ?
                    <Helmet>
                        <title>{t("seo_friendly.medical_info.title")}</title>
                        <meta name="description" content={t("seo_friendly.medical_info.desc")} />
                    </Helmet>
                    :
                    window.location.pathname?.includes?.("complaints") ?
                        <Helmet>
                            <title>{window.location.pathname?.includes?.("grievance-complaints") ? t("seo_friendly.grievance_complaint.title") : t("seo_friendly.vigilance_complaint.title")}</title>
                            <meta name="description" content={window.location.pathname?.includes?.("grievance-complaints") ? t("seo_friendly.grievance_complaint.desc") : t("seo_friendly.vigilance_complaint.desc")} />
                        </Helmet>
                        : window.location.pathname?.includes?.("tickets") ?
                            <Helmet>
                                <title>{t("seo_friendly.my_tickets.title")}</title>
                                <meta name="description" content={t("seo_friendly.my_tickets.desc")} />
                            </Helmet>
                            : window.location.pathname?.includes?.("transactions") ?
                                <Helmet>
                                    <title>{t("seo_friendly.my_transactions.title")}</title>
                                    <meta name="description" content={t("seo_friendly.my_transactions.desc")} />
                                </Helmet>
                                : window.location.pathname?.includes?.("lost-item") ?
                                    <Helmet>
                                        <title>{t("seo_friendly.my_lost_item.title")}</title>
                                        <meta name="description" content={t("seo_friendly.my_lost_item.desc")} />
                                    </Helmet>
                                    : <></>}
            <div className="container py-[25px] w-full h-full grid grid-cols-1">
                <div className="flex w-full h-full">
                    <div className="py-[30px] xlx:py-[35px] pr-[30px] xlx:pr-[35px] hidden flex-col gap-[20px] border-r border-primary border-opacity-[0.2] h-full min-w-[240px] md:flex">
                        <h3 className="text-primaryText dark:text-white font-semibold">{t("profile.settings")}</h3>

                        <div className="flex flex-col gap-[8px]">
                            {Array.isArray(tabs) && tabs?.map((item: any, index: number) => (
                                <Link to={!!params?.lang ? `/${params?.lang + item?.url}` : `${item?.url}`} key={index} className={`px-[13px] py-[8px] flex items-center gap-[8px] w-full ${window.location.pathname?.includes(item?.key) ? "bg-primary bg-opacity-[0.1] text-primaryText dark:text-white" : "text-blackDull dark:text-textBlackDull focus:bg-[#F5F5F5] hover:bg-[#F5F5F5] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e]"} rounded-[7px] font-medium text-base leading-tight`} >
                                    <div className="min-w-[19px] min-h-[19px] flex items-center justify-center">
                                        <item.icon className={`${window.location.pathname?.includes(item?.key) ? "fill-primaryText dark:fill-white" : "fill-blackDull dark:fill-textBlackDull"}`} />
                                    </div>
                                    {item?.name}
                                </Link>
                            ))}

                            <div className="w-full border-t border-primary border-opacity-[0.2]">
                                <button className="w-full  flex items-center gap-[8px] text-danger dark:text-darkDanger mt-[7px] font-medium text-base leading-tight px-[13px] py-[8px] focus:bg-[#F5F5F5] hover:bg-[#F5F5F5] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] rounded-[7px]" onClick={handleLogout}>
                                    <div className="min-w-[19px] min-h-[19px] flex items-center justify-center">
                                        <Logout className="min-w-[16px] dark:stroke-darkDanger stroke-danger" />
                                    </div>

                                    {t("auth.profile.logout")}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="fixed left-0 right-0 bottom-[30px] flex items-end justify-center z-[1] md:hidden">
                        <div className="bg-white shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] rounded-[10px] w-fit h-fit px-[10px] py-[8px] flex items-center gap-[10px]">
                            {Array.isArray(tabs) && tabs?.map((item: any, index: number) => (
                                <Link aria-label={item?.name} title={item?.name} to={!!params?.lang ? `/${params?.lang + item?.url}` : `${item?.url}`} key={index} className={`min-w-[30px] min-h-[30px] flex items-center justify-center ${window.location.pathname?.includes(item?.key) ? "bg-primary bg-opacity-[0.1] rounded-full" : ""}`} >
                                    <item.icon className={`${window.location.pathname?.includes(item?.key) ? "fill-primaryText" : "fill-blackDull"}`} />
                                </Link>
                            ))}
                        </div>
                    </div>
                    <div className="w-full md:w-[calc(100%-240px)] h-full">
                        {window.location.pathname?.includes?.("profile") ?
                            <Profile type={type} />
                            : window.location.pathname?.includes?.("medical") ?
                                <MedicalDetails />
                                :
                                (window.location.pathname?.includes?.("grievance-complaints") || window.location.pathname?.includes?.("vigilance-complaints")) ?
                                    <Complaints select={select} setSelect={setSelect} />
                                    : window.location.pathname?.includes?.("tickets") ?
                                        <Tickets />
                                        : window.location.pathname?.includes?.("transactions") ?
                                            <Transactions />
                                            : window.location.pathname?.includes?.("lost-item") ?
                                                <LostItem />
                                                : <></>}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Details;